import { Tabs } from 'antd';
import styled from 'styled-components';
import { COLOR } from '@styles/theme';

/** Route tabs in the secondary header — ink bar sits on the content edge. */
export const SecondaryRouteTabs = styled(Tabs)`
  width: 100%;
  align-self: stretch;

  &.secondary-route-tabs .ant-tabs-nav {
    margin-bottom: 0;
    align-items: center;
    min-height: 56px;
  }

  /* Header strip only — nested page tabs (e.g. Settings › Fulfillment) keep the nav rule */
  &.secondary-route-tabs:not(.with-nav-border) .ant-tabs-nav::before {
    border-bottom: none;
  }

  &.secondary-route-tabs .ant-tabs-nav-list {
    align-items: center;
  }

  &.secondary-route-tabs .ant-tabs-extra-content {
    display: flex;
    align-items: center;
    align-self: center;
  }

  &.secondary-route-tabs .ant-tabs-ink-bar {
    height: 2px;
    background: ${COLOR.black};
  }
`;
